import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import SEO from '../../components/SEO/SEO';


const About = () => {
    return (
        <div className="about-page">
            <SEO
                title="About Us"
                description="Learn about Digi Network's team of digital marketing experts, our proven track record, data-driven approach, and commitment to your business growth."
                canonical="/about"
            />
            {/* Hero Section */}
            <section className="about-hero">
                <div className="about-hero-bg"></div>
                <div className="container">
                    <div className="about-hero-content">
                        <div className="label">ABOUT DIGI NETWORK</div>
                        <h1>Digital Growth. Delivered with Precision.</h1>
                        <p>Digi Network is a full-service digital marketing agency dedicated to helping businesses dominate their markets through strategic SEO, high-converting paid advertising, and stunning web development. We combine technical expertise with creative execution to deliver measurable results that drive real business growth.</p>
                    </div>
                </div>
            </section>

            {/* Company Story */}
            <section className="about-story">
                <div className="container">
                    <div className="story-content">
                        <div className="story-text">
                            <div className="label">OUR STORY</div>
                            <h2>Built on a Foundation of Results</h2>
                            <p>Digi Network was founded with a simple mission: to help businesses achieve sustainable growth through data-driven digital marketing. What started as a small team of passionate marketers has grown into a full-service agency serving clients across the UAE and internationally.</p>
                            <p>We've delivered over 300% average traffic growth for our clients, managed millions in ad spend, and built hundreds of high-performing websites. Our success is measured by the success of our clients.</p>
                        </div>
                        <div className="story-visual">
                            {/* IMAGE PLACEHOLDER: Add office photo or team working together here (recommended size: 600x600px) */}
                            <div className="story-image-placeholder">
                                <p>🏢 Add Office Photo</p>
                            </div>
                        </div>
                        <div className="story-stats">
                            <div className="stat-item">
                                <div className="stat-value">150+</div>
                                <div className="stat-label">Projects Delivered</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">300%+</div>
                                <div className="stat-label">Avg. Traffic Growth</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">98%</div>
                                <div className="stat-label">Client Retention</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">24/7</div>
                                <div className="stat-label">Support Available</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission, Vision, Values */}
            <section className="about-mission">
                <div className="container">
                    <div className="mission-grid">
                        <div className="mission-item">
                            <div className="mission-icon">🎯</div>
                            <h3>Our Mission</h3>
                            <p>To empower businesses with innovative digital marketing strategies that drive sustainable growth, increase visibility, and deliver exceptional ROI through technical excellence and creative execution.</p>
                        </div>
                        <div className="mission-item">
                            <div className="mission-icon">🚀</div>
                            <h3>Our Vision</h3>
                            <p>To be the most trusted digital marketing partner for businesses looking to dominate their markets and achieve ambitious growth goals in the digital landscape.</p>
                        </div>
                        <div className="mission-item">
                            <div className="mission-icon">⭐</div>
                            <h3>Our Values</h3>
                            <p><strong>Integrity:</strong> Transparent reporting and honest communication.<br /><strong>Innovation:</strong> Cutting-edge strategies and continuous learning.<br /><strong>Impact:</strong> Results-driven approach focused on measurable outcomes.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Team Section */}
            <section className="about-team">
                <div className="container">
                    <div className="label">Our Team</div>
                    <h2>Meet The Experts</h2>
                    <div className="team-grid">
                        <div className="team-member">
                            <div className="team-photo">
                                {/* IMAGE PLACEHOLDER: Add team member photo here (recommended size: 300x300px) */}
                                <p className="team-photo-text">👤 Add Photo</p>
                            </div>
                            <h4>John Anderson</h4>
                            <p>CEO & Founder</p>
                        </div>
                        <div className="team-member">
                            <div className="team-photo">
                                {/* IMAGE PLACEHOLDER: Add team member photo here (recommended size: 300x300px) */}
                                <p className="team-photo-text">👤 Add Photo</p>
                            </div>
                            <h4>Sarah Mitchell</h4>
                            <p>Head of SEO</p>
                        </div>
                        <div className="team-member">
                            <div className="team-photo">
                                {/* IMAGE PLACEHOLDER: Add team member photo here (recommended size: 300x300px) */}
                                <p className="team-photo-text">👤 Add Photo</p>
                            </div>
                            <h4>David Chen</h4>
                            <p>PPC Director</p>
                        </div>
                        <div className="team-member">
                            <div className="team-photo">
                                {/* IMAGE PLACEHOLDER: Add team member photo here (recommended size: 300x300px) */}
                                <p className="team-photo-text">👤 Add Photo</p>
                            </div>
                            <h4>Emily Roberts</h4>
                            <p>Creative Director</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-choose">
                <div className="container">
                    <div className="label">Why Choose Us</div>
                    <h2>What Sets Us Apart</h2>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-icon">🎯</div>
                            <h3>Data-Driven Approach</h3>
                            <p>Every decision is backed by comprehensive analytics and market research to ensure optimal results.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-icon">🚀</div>
                            <h3>Proven Track Record</h3>
                            <p>Over 150 successful campaigns with an average ROI increase of 500% across all clients.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-icon">💡</div>
                            <h3>Innovation First</h3>
                            <p>We stay ahead of trends and implement cutting-edge strategies to keep you competitive.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-icon">🤝</div>
                            <h3>Dedicated Support</h3>
                            <p>Your success is our priority. We provide ongoing support and transparent communication.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="about-cta">
                <div className="container">
                    <h2>Let's Build Your Growth Engine</h2>
                    <p>Partner with a team that's committed to your success</p>
                    <Link to="/contact" className="btn btn-primary">
                        Start Your Project
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default About;
